// hooks/travelRequest/reducer.js
export const ACTIONS = {
    SET_LOADING: 'SET_LOADING',
    SET_ERROR: 'SET_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',
    SET_REQUESTS: 'SET_REQUESTS',
    SET_SELECTED_REQUEST: 'SET_SELECTED_REQUEST',
    ADD_REQUEST: 'ADD_REQUEST',
    UPDATE_REQUEST: 'UPDATE_REQUEST',
    DELETE_REQUEST: 'DELETE_REQUEST',
    SET_REQUEST_STATUS: 'SET_REQUEST_STATUS',
    ADD_REQUEST_COMMENT: 'ADD_REQUEST_COMMENT',
    UPDATE_REQUEST_APPROVER: 'UPDATE_REQUEST_APPROVER',
    SET_FILTER: 'SET_FILTER',
    SET_SORT: 'SET_SORT',
    SET_PAGE: 'SET_PAGE',
    UPDATE_REQUEST_ATTACHMENTS: 'UPDATE_REQUEST_ATTACHMENTS',
    SET_REQUEST_HISTORY: 'SET_REQUEST_HISTORY',
    SET_PENDING_REQUESTS: 'SET_PENDING_REQUESTS',
    SET_PER_DIEM_DATA: 'SET_PER_DIEM_DATA',
    CLEAR_PER_DIEM_DATA: 'CLEAR_PER_DIEM_DATA',
    BULK_UPDATE_REQUESTS: 'BULK_UPDATE_REQUESTS',
    SET_STATUSES: 'SET_STATUSES',
    SET_LINE_ACTIVITIES: 'SET_LINE_ACTIVITIES',
    SET_TRAVEL_MATRIX: 'SET_TRAVEL_MATRIX'
};

export const initialState = {
    requests: [],
    statuses: [],
    lineActivities: [],

    selectedRequest: null,
    loading: false,
    error: null,
    filter: {
        status: null,
        requestType: null,
        dateRange: {
            start: null,
            end: null
        },
        priority: null,
        department: null
    },
    pagination: {
        page: 0,
        size: 10,
        total: 0
    },
    sort: {
        field: 'createdAt',
        direction: 'desc'
    },
    requestHistory: [],
    pendingRequests: [],

    perDiem: {
        data: null,
        totalAmount: 0,
        allowances: []
    },
    travelMatrix: []
};

export const travelRequestReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case ACTIONS.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        case ACTIONS.CLEAR_ERROR:
            return {
                ...state,
                error: null
            };

        case ACTIONS.SET_REQUESTS:
            return {
                ...state,
                requests: action.payload.content,
                pagination: {
                    ...state.pagination,
                    total: action.payload.totalElements || action.payload.length,
                    page: action.payload.number || 0
                },
                loading: false
            };

        case ACTIONS.SET_SELECTED_REQUEST:
            return {
                ...state,
                selectedRequest: action.payload,
                loading: false
            };

        case ACTIONS.ADD_REQUEST:
            if (!action.payload) {
                return state;
            }
            return {
                ...state,
                requests: [action.payload, ...(state.requests || [])],
                loading: false,
                error: null
            };

        case ACTIONS.UPDATE_REQUEST:
            return {
                ...state,
                requests: state.requests.map((request) => (request.id === action.payload.id ? action.payload.data : request)),
                selectedRequest: state.selectedRequest?.id === action.payload.id ? action.payload.data : state.selectedRequest,
                loading: false
            };

        case ACTIONS.DELETE_REQUEST:
            return {
                ...state,
                requests: state.requests.filter((request) => request.id !== action.payload),
                selectedRequest: state.selectedRequest?.id === action.payload ? null : state.selectedRequest,
                loading: false
            };

        case ACTIONS.SET_REQUEST_STATUS:
            return {
                ...state,
                requests: state.requests.map((request) =>
                    request.id === action.payload.id ? { ...request, status: action.payload.status } : request
                ),
                selectedRequest:
                    state.selectedRequest?.id === action.payload.id
                        ? { ...state.selectedRequest, status: action.payload.status }
                        : state.selectedRequest
            };

        case ACTIONS.ADD_REQUEST_COMMENT:
            return {
                ...state,
                selectedRequest: state.selectedRequest && {
                    ...state.selectedRequest,
                    comments: [...state.selectedRequest.comments, action.payload]
                }
            };

        case ACTIONS.UPDATE_REQUEST_APPROVER:
            return {
                ...state,
                selectedRequest: state.selectedRequest && {
                    ...state.selectedRequest,
                    approvers: state.selectedRequest.approvers.map((approver) =>
                        approver.approverId === action.payload.approverId ? { ...approver, ...action.payload } : approver
                    )
                }
            };

        case ACTIONS.UPDATE_REQUEST_ATTACHMENTS:
            return {
                ...state,
                selectedRequest: state.selectedRequest && {
                    ...state.selectedRequest,
                    attachments: action.payload
                }
            };

        case ACTIONS.SET_REQUEST_HISTORY:
            return {
                ...state,
                requestHistory: action.payload
            };

        case ACTIONS.SET_FILTER:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    ...action.payload
                },
                pagination: {
                    ...state.pagination,
                    page: 0
                }
            };

        case ACTIONS.SET_SORT:
            return {
                ...state,
                sort: action.payload
            };

        case ACTIONS.SET_PAGE:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload
                }
            };

        case ACTIONS.SET_PER_DIEM_DATA:
            return {
                ...state,
                perDiem: {
                    data: action.payload,
                    totalAmount: action.payload.totalAmount,
                    allowances: action.payload.allowances
                },
                loading: false
            };

        case ACTIONS.CLEAR_PER_DIEM_DATA:
            return {
                ...state,
                perDiem: {
                    data: null,
                    totalAmount: 0,
                    allowances: []
                }
            };
        case ACTIONS.SET_PENDING_REQUESTS:
            return {
                ...state,
                pendingRequests: Array.isArray(action.payload) ? action.payload : action.payload || [],
                loading: false
            };

        case ACTIONS.BULK_UPDATE_REQUESTS:
            return {
                ...state,
                pendingRequests: state.pendingRequests.map((request) =>
                    action.payload.travelRequestIds.includes(request.id) ? { ...request, status: action.payload.status } : request
                ),
                loading: false
            };

        case ACTIONS.SET_LINE_ACTIVITIES:
            return {
                ...state,
                lineActivities: Array.isArray(action.payload) ? action.payload : [],
                loading: false
            };

        case ACTIONS.SET_STATUSES:
            return {
                ...state,
                statuses: Array.isArray(action.payload) ? action.payload : [],
                loading: false
            };

        case ACTIONS.SET_TRAVEL_MATRIX:
            return {
                ...state,
                travelMatrix: Array.isArray(action.payload) ? action.payload : [],
                loading: false
            };

        default:
            return state;
    }
};
